/** Specimen PDF: waits for the background printing, then asks for a signed, time-limited link. */

import { documentsFilesLinkRetrieve, useDocumentsFilesRetrieve } from "@agencyos/api-client";
import { ExternalLink } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export function SpecimenLink({ id }: { id: string }) {
  const { t } = useTranslation();
  const document = useDocumentsFilesRetrieve(id, {
    query: {
      refetchInterval: (query) => {
        const data = query.state.data;
        return data?.status === 200 && data.data.status === "pending" ? 1500 : false;
      },
    },
  });
  const [url, setUrl] = useState<string | null>(null);
  const status = document.data?.status === 200 ? document.data.data.status : "pending";

  useEffect(() => {
    if (status !== "ready" || url) return;
    void documentsFilesLinkRetrieve(id).then((response) => {
      if (response.status === 200) setUrl(response.data.url);
    });
  }, [status, id, url]);

  if (status === "failed")
    return (
      <p role="alert" className="ko">
        {t("contracts.pdf.failed")}
      </p>
    );
  if (!url)
    return (
      <p role="status" className="muted">
        {t("contracts.pdf.printing")}
      </p>
    );
  return (
    <p role="status">
      <a className="link" href={url} target="_blank" rel="noreferrer">
        <ExternalLink size={14} aria-hidden="true" /> {t("contracts.pdf.openSpecimen")}
      </a>
    </p>
  );
}
